import { L2CategoryConfig, withIaCode } from '@app/pages/shop/categoryConfig';
import Box from '@redbubble/design-system/src/Box';
import { useIntl } from '@redbubble/next/intl';
import {
  AnalyticsContextTypes,
  AnalyticsStorage,
  AnalyticsStorageKeys,
} from '@redbubble/next-analytics/gtm';
import { Topic } from '../RelatedTopicsList';
import styles from './L2PillsList.module.scss';

export interface L2PillsListProps {
  l2Categories: L2CategoryConfig[];
  iaCode?: string | null;
  testId?: string;
}

const handleClick = (title: string, position: number) => () => {
  AnalyticsStorage.setValue(
    AnalyticsStorageKeys.RefContextType,
    AnalyticsContextTypes.CategoryPill
  );
  AnalyticsStorage.setValue(
    AnalyticsStorageKeys.RefContextIndex,
    `${position}`
  );
  AnalyticsStorage.setValue(AnalyticsStorageKeys.RefContextLabel, title);
};

export const L2PillsList: React.FC<L2PillsListProps> = ({
  l2Categories,
  iaCode,
  testId = 'l2-pills-list',
}) => {
  const intl = useIntl();

  if (!l2Categories.length) return null;

  return (
    <Box className={styles.list} data-testid={testId}>
      {l2Categories.map((l2, index) => {
        const title = intl.formatMessage(l2.title);

        return (
          <Topic
            key={l2.slug}
            title={title}
            element="a"
            href={withIaCode(l2.seeAllPath, iaCode)}
            onClick={handleClick(title, index)}
          />
        );
      })}
    </Box>
  );
};
